import { ref } from '@vue/composition-api'

let alerts;

export default function useAlerts () {
    if (alerts == undefined){
        alerts = ref([]);
    }

    const addAlert = (alertMsg, alertClass, dismissTimeout) => {
        alerts.value.push({
            msg: alertMsg,
            class: alertClass,
            timeout: dismissTimeout
        });
    }

    const removeAlert = (index) => {
        alerts.value.splice(index, 1);
    }

    return {
        alerts,
        addAlert,
        removeAlert
    }
}
